import { Building2, Clock } from "lucide-react";
import type { Licitacion } from "@/types/licitacion";
import { EstadoBadge } from "./estado-badge";

interface LicitacionDetailHeaderProps {
  licitacion: Licitacion;
}

function formatPresupuesto(value: number | null): string {
  if (value === null) return "Sin presupuesto";
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
}

function getDaysRemaining(fechaLimite: string | null): {
  label: string;
  colorClass: string;
} {
  if (!fechaLimite) {
    return { label: "Sin fecha límite", colorClass: "text-gray-500" };
  }
  const days = Math.ceil((new Date(fechaLimite).getTime() - Date.now()) / (1000 * 60 * 60 * 24));
  if (days < 0) return { label: "Vencida", colorClass: "text-red-600" };
  if (days === 0) return { label: "Vence hoy", colorClass: "text-red-600" };
  if (days <= 7) return { label: `${days} días restantes`, colorClass: "text-orange-600" };
  if (days <= 14) return { label: `${days} días restantes`, colorClass: "text-yellow-600" };
  return { label: `${days} días restantes`, colorClass: "text-green-600" };
}

export function LicitacionDetailHeader({ licitacion }: LicitacionDetailHeaderProps) {
  const deadline = getDaysRemaining(licitacion.fecha_limite);

  return (
    <div className="bg-white p-6 border-b border-gray-200">
      <h1 className="text-2xl font-bold text-gray-900">{licitacion.titulo}</h1>
      <div className="flex items-center gap-2 mt-2 text-gray-600">
        <Building2 className="h-4 w-4" />
        <span className="text-sm">{licitacion.organismo}</span>
      </div>
      <div className="flex flex-wrap items-center gap-4 mt-4">
        <EstadoBadge estado={licitacion.estado} />
        <span className="text-sm font-medium text-gray-700">
          {formatPresupuesto(licitacion.presupuesto_base)}
        </span>
        <div className={`flex items-center gap-1.5 text-sm ${deadline.colorClass}`}>
          <Clock className="h-4 w-4" />
          <span>{deadline.label}</span>
        </div>
      </div>
    </div>
  );
}
